module.exports = __webpack_public_path__ + "img/rgt.d94d792f.svg";